<template>
	<slot></slot>
</template>
